<template>
	<slot></slot>
</template>
